import { Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { UtilsService } from '../../../services/shared/utils/utils.service';

@Component({
  selector: 'app-card-select-component',
  templateUrl: './card-select-component.component.html',
  styleUrls: ['./card-select-component.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatCard, MatCardContent, MatOptionModule]
})
export class CardSelectComponentComponent {

  // Single option data
  @Input() option: any;

  // Selection state
  @Input() checked: boolean = false;

  // Disabled state
  @Input() disabled: boolean = false;

  // Emit value on click
  @Output() cardChange = new EventEmitter<any>();

  // Bind disabled class to host element for CSS styling
  @HostBinding('class.disabled') get isDisabled() {
    return this.disabled;
  }
  @ViewChild('htmlWrapper')
  set htmlWrapper(ref: ElementRef<HTMLElement>) {
    if (!ref) return;
    if (!this.isAndroidOrWindows()) {
      ref.nativeElement.addEventListener(
        'click',
        this.onHtmlClick,
        true
      );
    }
  }
  constructor(private utils: UtilsService) { }
  onClick() {
    // Prevent action if disabled
    if (this.disabled) return;

    // Notify parent with the selected value
    this.cardChange.emit(this.option.value);
  }

  private onHtmlClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const link = target.closest('a[data-href]') as HTMLAnchorElement;

    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    const href = link.dataset['href'];
    if (!href) return;

    window.open(href, '_blank', 'noopener');
  };

  isAndroidOrWindows() {
    return this.utils.isAndroidOrWindows();
  }

  sanitizeHtml(text: string) {
    return this.utils.sanitizeHtml(text);
  }
}
